export const style = `
.editor-container {
    display: table-cell;
    height: -webkit-fill-available;
    width: -webkit-fill-available;
}

/* Svg */
.wrapperEditor {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1.5em;
}

    .wrapperEditor svg {
        width: 100%;
        height: 100%;
    }
    .wrapperEditor > div{
        width:100%;
        height:100%;
        display:flex;
        place-content:center;
    }
    .zoomable-svg-container {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 100%;
        height: 100%;
    }

@media (max-height: 700px) {
    .wrapperEditor svg {
        max-width: 20em;
    }
}

@media (max-height: 800px) {
}


/*tooltip*/
.tooltip {
    display: flex;
    position: absolute;
    justify-content: flex-start;
    align-items: flex-start;
    left: 1em;
    padding: 0.5em;
    background-color: rgba(128, 128, 128, 0.1);
}
/* Zoom tools*/
.zoom-buttons-container {
    display: flex;
    position: absolute;
    justify-content: end;
    align-items: flex-end;
    gap: 10px;
    margin: 0.5em;
}

.zoom-button {
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 20px;
    margin-left: 10px;
    transition: transform 0.3s, filter 0.3s;
}

    .zoom-button:hover {
        transform: scale(1.1);
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
    }

/* Grid container*/
.grid-container {
    margin-top: var(--size-s);
    margin-bottom: var(--size-l);
    padding: 0 var(--size-s);
    padding-right: 4em;
}

/* First column */

.column .first-column {
    width: 25% !important;
}

.first-column .first-row {
    padding-bottom: var(--size-l);
}

    .first-column .first-row .asset-section-name {
        font-size: 1.5vw;
        margin: 0 0 0 0;
    }

    .first-column .first-row .asset-name {
        font-size: 1vw;
    }

.first-column .second-row {
    padding-left: 1em;
}

    .first-column .second-row label {
        font-size: 1vw !important;
    }

    .first-column .second-row ._labelAndAsteriskContainer_19cin_203 {
        font-size: 1vw !important;
    }

    .first-column .second-row ._inputField_19cin_35:not(._isMultilineInput_19cin_75)._small_19cin_9 ._baseInputBase_19cin_78 {
        font-size: 1vw !important;
    }

    .first-column .second-row i.icon {
        font-size: 1vw !important;
    }

    .first-column .second-row ._inputField_19cin_35:not(._isMultilineInput_19cin_75)._small_19cin_9 {
        height: 2vw !important;
    }

    .first-column .second-row ._inputContainer_19cin_24._spanning_19cin_32 {
        margin-bottom: 0.3vw;
    }

    .first-column .second-row ._icons_19cin_43 {
        height: 2vw !important;
    }
/* Second column */
.column .second-column {
    width: 75% !important;
}

.second-column .first-row {
    font-size: 0.9vw;
}

.second-column .second-row {
    display: flex;
    justify-content: flex-end;
    border: 1px solid black;
    overflow: hidden;
    align-items: end;
}

.second-column .third-row {
    display: inline-flex;
    margin-top: 1em;
    gap: 1em;
}

    .second-column .third-row .instructionNotes {
        font-size: 1vw;
    }

/*Second column Wizard component*/
.wizard-component {
    margin: 0 0 0 0 !important;
}

._container_mn06z_1 {
    margin-bottom: 0 !important;
    padding-top: 0 !important;
}

    ._container_mn06z_1 ._indicators_mn06z_1 ._indicator_mn06z_1 {
        width: 100% !important;
    }

    ._container_mn06z_1 ._indicators_mn06z_1 {
        width: 100% !important;
    }

    ._container_mn06z_1 ._indicatorStep_mn06z_115 {
        flex-grow: 1;
    }

    ._container_mn06z_1 ._nameLabel_mn06z_1 > p {
        font-size: 0.8vw !important;
    }

    ._container_mn06z_1 ._nameLabel_mn06z_1._activeNameLabel_mn06z_1 > p {
        font-size: 0.8vw !important;
    }
/*Right sidebar*/
#rightSidebar {
    width: 14em;
}

    #rightSidebar ._sidebarTitle_1xw9o_1 {
        flex-direction: row-reverse !important;
        padding-right: var(--size-m) !important;
        padding-left: 0px !important;
        border-bottom: 1px solid gray;
    }

        #rightSidebar ._sidebarTitle_1xw9o_1 ._iconButton_1xw9o_1 {
            transform: scaleX(-1);
        }

    #rightSidebar h5 {
        margin-left: 0.5em;
        font-size: 1em;
    }

    #rightSidebar hj {
    }

    #rightSidebar .idPairRectangle {
        border-bottom: 1px solid black;
        padding: 5px 10px;
        display: flex;
        align-items: center;
    }

    #rightSidebar .hole-change-spacer{
        margin: 0 5px
    }

/* Path style*/
.wrapperEditor path:not(.ws-hole):not(.ws-liner):not(.ws-regionTemp):not(.ws-referenceTemp):not(.ws-element):not(.selectedPath):not(.ws-wearReferencePlaneTemp) {
    fill: transparent !important;
    stroke-width: 1px;
    stroke: black;
}

#rightSidebar ._sidebarContent_1n9uc_1 {
    padding: 0px !important;
}

.edit-box {
    flex-direction: column;
    height: 5.6em;
    border: 2px solid black;
    position: absolute !important;
    padding: 15px;
    display: flex;
    background-color: white;
    width: max-content;
}

    .edit-box label {
        font-weight: 400;
    }

    .edit-box button {
        align-self: self-end;
    }

    .edit-box .box-title {
        margin-bottom: 0.2em;
    }

    .edit-box .box-body {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 10px;
    }

        .edit-box .box-body .hole-input {
            width: 3em !important;
        }

        edit-box .box-body .reference-input {
            width: 4em !important;
        }
        .edit-box .box-body .liner-location-draw-ref-input{
            width: 9em !important;
        }
.ws-liner {
    fill: #CBCBCBB2;
    cursor: pointer;
}

    .ws-liner:hover {
        fill: rgba(0, 75, 255, 0.25) ;
    }
    

.selectedPath {
    fill: #D4B1C0B2 !important;
}

.ws-hole {
    position: relative;
    fill: gold !important;
    stroke: black;
    stroke-width: 1px;
}

    .ws-hole:hover {
        fill: rgba(0, 148, 255, 0.25) ;
    }

.ws-wearReferencePlaneTemp {
    fill: rgba(144, 238, 144, 0.5) !important;
}

.ws-referenceTemp {
    fill: rgba(0, 0, 0, 0.7) !important;
}

.ws-regionTemp {
    fill: rgba(255, 255, 0, 0.4);
    stroke: #000000 ;
    stroke-width: 1.15px;
    stroke-miterlimit: 4;
    stroke-dasharray: 6;
    pointer-events: none;
}

    .ws-regionTemp:hover {
        fill: rgba(0, 220, 255, 0.25) ;
    }
`
